import { LegalPageLayout, LegalSections } from "../components/LegalPageLayout";

export default function Warranty() {
  return (
    <LegalPageLayout pageKey="warranty">
      <LegalSections pageKey="warranty" />
    </LegalPageLayout>
  );
}
